import React from "react";
import GroupedColumns from "./GroupColumns";

export default function GroupColumnsList(props) {
  const getGroupingColumns = (groupedColumns) => {
    const menuColumns = groupedColumns.map((column, index) => {
      return (
        <GroupedColumns
          key={index}
          title={index == 0 ? "Group By" : "Then By"}
          column={column} //{props.groupedColumnNames[index]}
          changeColumn={(target) => {
            props.changeColumn(index, target);
          }}
          deleteColumn={() => {
            props.deleteColumn(column);
          }}
          changeGroupOptions={(target) => {
            props.changeGroupOptions(index, target);
          }}
        />
      );
    });
    return menuColumns;
  };

  return (
    <div>
      {props.groupedColumns.length > 0 ? (
        getGroupingColumns(props.groupedColumns)
      ) : (
        <div
          style={{
            color: "#bbb",
            paddingTop: 15,
            paddingLeft: 15,
            fontSize: 13,
          }}
        >
          No groupings applied to this view
        </div>
      )}
    </div>
  );
}
